<div class="gt-routes-list-containerss">
    <dx-data-grid #masterGrid id="masterGrid" [dataSource]="costTemplates" [repaintChangesOnly]="true" [keyExpr]="'id'"
        class="templateCostConfigForm" (onEditingStart)="editTemplate($event)" showRowLines="true"
        (onRowInserting)="insertTemplate($event)" (onRowExpanding)="onMasterRowExpanding($event)"
        (onRowRemoved)="deleteTemplate($event)" (onInitNewRow)="onInitNewRow($event)">
        <dxo-search-panel [visible]="true" i18n-placeholder="@@search..."
          placeholder="Search..."></dxo-search-panel>
        <dxo-header-filter visible="true"></dxo-header-filter>
        <dxo-toolbar>
            <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
            <dxi-item width="50%">
                <div class="gt-flex-dir-row">
                    <dx-button i18n-text="@@addCostTemplateCaps" text="ADD COST TEMPLATE" [visible]="true" icon="add"
                        (onClick)="resetTemplateForAdd();masterGrid.instance.addRow()"
                       class="gpd-button">
                    </dx-button>
                </div>
            </dxi-item>
        </dxo-toolbar>

    <dxo-editing mode="form" [confirmDelete]="false">
      <dxo-form colCount="1">
        <dxi-item template="templateConfigForm">
          <div *dxTemplate="let item of 'templateConfigForm'">
            <form (submit)="$event.preventDefault(); saveCostTemplate($event)">
              <dx-validation-group>
                <dx-form [formData]="selectedTemplate" [colCount]="1" validationGroup="templateConfigForm">
                  <dxi-item itemType="group" [colCount]="1">
                    <dxi-item
                      dataField="templateName"
                      editorType="dxTextBox"
                      [editorOptions]="{ maxLength: 150 }"
                      [validationRules]="[{ type: 'required', message: titleRequired }]"
                    >
                      <dxo-label i18n-text="@@templateName" text="Template Name" />
                    </dxi-item>

                    <dxi-item
                      dataField="areaTypeId"
                      editorType="dxSelectBox"
                      [editorOptions]="{
                        editorType: 'dxSelectBox',
                        dataSource: projectAreaTypes,
                        displayExpr: 'itemName',
                        valueExpr: 'itemId',
                        searchEnabled: false,
                      }"
                    >
                      <dxo-label i18n-text="@@areaType" text="Area Type" />
                    </dxi-item>

                    <dxi-item
                      dataField="sizeRange"
                      editorType="dxSelectBox"
                      [editorOptions]="{
                        editorType: 'dxSelectBox',
                        dataSource: projectSizeRanges,
                        displayExpr: 'itemName',
                        placeholder: descriptionPlaceholder,
                        valueExpr: 'itemName',
                        searchEnabled: true,
                        acceptCustomValue: true,
                        onCustomItemCreating: addCustomSizeRangeValue,
                        maxLength: 50,
                      }"
                    >
                      <dxo-label i18n-text="@@description" text="Description" />
                    </dxi-item>
                  </dxi-item>

                  <dxi-item
                    itemType="group"
                    [colCountByScreen]="{ sm: 2, md: 2 }"
                    cssClass="buttons-group"
                    [verticalAlignment]="true"
                  >
                    <dx-button
                      i18n-text="@@cancel"
                      text="Cancel"
                      stylingMode="contained"
                      class="gt-button gt-btn-left gt-blk-txt add-site-icon"
                      [useSubmitBehavior]="false"
                      (onClick)="onTemplateEditCanceling($event)"
                    ></dx-button>

                    <dx-button
                      i18n-text="@@confirmCaps"
                      text="CONFIRM"
                      stylingMode="contained"
                      validationGroup="templateConfigForm"
                      [useSubmitBehavior]="true"
                      class="gt-button gt-btn-right gt-blk-txt add-site-icon"
                    ></dx-button>
                  </dxi-item>
                </dx-form>
              </dx-validation-group>
            </form>
          </div>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxi-column
      dataField="templateName"
      cellTemplate="nameTemplate"
      i18n-caption="@@templateName"
      caption="Template Name"
      [allowFiltering]="true"
    >
      <div *dxTemplate="let item of 'nameTemplate'">
        <div class="cell-with-buttons">
          <span>{{ item.data.templateName }}</span>
        </div>
      </div>
    </dxi-column>

    <dxi-column dataField="areaTypeId" i18n-caption="@@areaType" caption="Area Type" [allowFiltering]="true">
      <dxo-lookup [dataSource]="projectAreaTypes" valueExpr="itemId" displayExpr="itemName"></dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="sizeRange"
      cellTemplate="sizeTemplate"
      editCellTemplate="editSizeTemplate"
      [allowFiltering]="true"
      i18n-caption="@@description"
      caption="Description"
    >
      <div *dxTemplate="let item of 'sizeTemplate'">
        <span>{{ item.data.sizeRange }}</span>
      </div>
    </dxi-column>

    <dxi-column
      dataField=""
      [visible]="true"
      allowEditing=" false"
      cellTemplate="buttonCellTemplate"
      [width]="'auto'"
      [formItem]="{ visible: false }"
    >
      <div class="cell-with-buttons" *dxTemplate="let item of 'buttonCellTemplate'">
        <div class="cell-button-container">
          <dx-button icon="edit" class="cell-button" (onClick)="initEditCostTemplate(item)"> </dx-button>
          <dx-button icon="clear" class="cell-button" (onClick)="initDeleteCostTemplate(item)"> </dx-button>
        </div>
      </div>
    </dxi-column>

    <dxo-master-detail [enabled]="true" template="templateCosts" width="100%"></dxo-master-detail>
    <div *dxTemplate="let cost of 'templateCosts'">
      <dx-data-grid
        [id]="cost.data.id"
        [dataSource]="cost.data.templateCosts"
        (onRowInserted)="onCostRowInserted($event)"
        (onSaving)="onCostRowUpdated($event, cost)"
        (onEditorPrepared)="onCostEditorPrepared($event)"
        (onEditingStart)="onCostEditingStart($event)"
        [repaintChangesOnly]="true"
        (onCellDblClick)="showCost($event, cost.data)"
        showRowLines="true"
        [repaintChangesOnly]="true"
      >
        <dxo-toolbar>
          <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
          <dxi-item width="50%">
            <div class="gt-flex-dir-row">
              <dx-button
                i18n-text="@@addNewCostCaps"
                text="ADD NEW COST"
                [visible]="true"
                icon="add"
                (onClick)="addCostRow($event, cost.data.id)"
                class="gt-button gt-btn-right gt-blk-txt add-site-icon"
              >
              </dx-button>
            </div>
          </dxi-item>
        </dxo-toolbar>

        <dxo-editing mode="form" [confirmDelete]="false" width="100%">
          <dxo-form colCount="1">
            <dxi-item template="templateCostConfigForm" colSpan="2">
              <div *dxTemplate="let item of 'templateCostConfigForm'">
                <form (submit)="$event.preventDefault(); onCostRowUpdated($event, cost)">
                  <dx-validation-group>
                    <dx-form
                      [formData]="selectedTemplateCost"
                      [colCount]="1"
                      width="100%"
                      validationGroup="templateCostConfigForm"
                    >
                      <dxi-item itemType="group" [colCount]="1" [colSpan]="1">
                        <dxi-item dataField="costCategoryId" template="editCategoryTemplate" [colSpan]="1">
                          <dxo-label i18n-text text="Category" />
                          <div *dxTemplate="let item of 'editCategoryTemplate'">
                            <dx-drop-down-box
                              [(value)]="selectedTemplateCost.costCategoryId"
                              valueExpr="id"
                              displayExpr="categoryName"
                              i18n-placeholder
                              placeholder="Select a category..."
                              [showClearButton]="true"
                              [(opened)]="isTreeBoxOpened"
                              [dataSource]="treeDataSourceSorted"
                              [showDropDownButton]="true"
                            >
                              <dx-validator>
                                <dxi-validation-rule
                                  type="required"
                                  i18n-message="@@categoryIsRequired"
                                  message="Category is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>

                              <div *dxTemplate="let data of 'content'">
                                <dx-tree-view
                                  [dataSource]="treeDataSourceSorted"
                                  [searchEnabled]="true"
                                  dataStructure="plain"
                                  keyExpr="treeId"
                                  parentIdExpr="treeCategoryId"
                                  selectionMode="single"
                                  displayExpr="categoryName"
                                  [selectByClick]="true"
                                  (onItemSelectionChanged)="treeView_itemSelectionChanged($event, selectedTemplateCost)"
                                  (onInitialized)="treeView_itemSelectionChanged($event, selectedTemplateCost)"
                                >
                                </dx-tree-view>
                              </div>
                            </dx-drop-down-box>
                          </div>
                          <dxi-validation-rule
                            type="required"
                            i18n-message="@@categoryIsRequired"
                            message="Category is required"
                          >
                          </dxi-validation-rule>
                        </dxi-item>

                        <dxi-item itemType="group" [colSpan]="1" [colCount]="3">
                          <dxi-item
                            dataField="isKwpCost"
                            editorType="dxCheckBox"
                            [colSpan]="1"
                            [editorOptions]="{
                              editorType: 'dxCheckBox',
                              value: selectedTemplateCost.isKwpCost,
                              onValueChanged: isKwpCostChanged,
                              onInitialized: iskwpInitialized(selectedTemplateCost),
                            }"
                          >
                            <dxo-label i18n-text="@@isKwpCost" text="Cost per size unit" />
                          </dxi-item>

                          <dxi-item
                            dataField="attractsUst"
                            editorType="dxCheckBox"
                            [colSpan]="1"
                            [editorOptions]="{ editorType: 'dxCheckBox', value: selectedTemplateCost.attractsUst }"
                          >
                            <dxo-label i18n-text text="Attracts Ust" />
                          </dxi-item>

                          <!-- <dxi-item
                            dataField="isSiteCost"
                            editorType="dxCheckBox"
                            [colSpan]="1"
                            [editorOptions]="{ editorType: 'dxCheckBox', value: selectedTemplateCost.isSiteCost }"
                          >
                            <dxo-label i18n-text text="Site Cost" />
                          </dxi-item> -->
                        </dxi-item>

                        <dxi-item
                          *ngIf="EPKWFormatting"
                          dataField="costNett"
                          editorType="dxNumberBox"
                          [colSpan]="1"
                          [editorOptions]="{ maxLength: 50, format: '#,##0.00 ' + perUnitLabel(sizeUnit) }"
                          [validationRules]="[{ type: 'required', message: costNettRequired }]"
                        >
                          <dxo-label i18n-text text="Cost Nett" />
                        </dxi-item>

                        <dxi-item
                          *ngIf="!EPKWFormatting"
                          dataField="costNett"
                          editorType="dxNumberBox"
                          [colSpan]="1"
                          [editorOptions]="{ maxLength: 50, format: '#,##0.00 €' }"
                          [validationRules]="[{ type: 'required', message: costNettRequired }]"
                        >
                          <dxo-label i18n-text text="Cost Nett" />
                        </dxi-item>

                        <dxi-item dataField="" template="timingTemplate" [colSpan]="1" [isRequired]="true">
                          <dxo-label i18n-text text="Milestone Offset" />
                          <div *dxTemplate="let item of 'timingTemplate'" class="gt-flex-dir-row">
                            <dx-number-box width="100px" [(value)]="selectedTemplateCost.milestoneOffsetValue">
                              <dx-validator [validationGroup]="'templateCostConfigForm'">
                                <dxi-validation-rule
                                  type="required"
                                  i18n-message="@@milestoneIsRequired"
                                  message="Milestone information is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-number-box>
                            <span i18n class="form-inline-span-text">weeks</span>
                            <dx-select-box
                              width="auto"
                              i18n-placeholder
                              placeholder="Before/After"
                              [dataSource]="milestoneOffsetDirections"
                              displayExpr="text"
                              valueExpr="text"
                              [(value)]="selectedTemplateCost.milestoneOffsetDirection"
                              [showClearButton]="true"
                            >
                              <dx-validator [validationGroup]="'templateCostConfigForm'">
                                <dxi-validation-rule
                                  type="required"
                                  i18n-message="@@milestoneIsRequired"
                                  message="Milestone information is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-select-box>

                            <dx-select-box
                              width="auto"
                              i18n-placeholder
                              placeholder="Select Milestone"
                              [dataSource]="milestones"
                              [dropDownOptions]="{ width: 300 }"
                              (onSelectionChanged)="changeMilestone($event)"
                              [(value)]="selectedTemplateCost.costMilestoneId"
                              valueExpr="id"
                              displayExpr="name"
                              [showClearButton]="true"
                            >
                              <dx-validator [validationGroup]="'templateCostConfigForm'">
                                <dxi-validation-rule
                                  type="required"
                                  i18n-message="@@milestoneIsRequired"
                                  message="Milestone information is required"
                                >
                                </dxi-validation-rule>
                              </dx-validator>
                            </dx-select-box>

                            <span i18n class="form-inline-span-text">milestone.</span>
                          </div>
                        </dxi-item>

                        <dxi-item
                          dataField="notes"
                          editorType="dxTextArea"
                          [colSpan]="1"
                          [editorOptions]="{ value: selectedTemplateCost.notes }"
                        >
                          <dxo-label i18n-text text="Notes" />
                        </dxi-item>
                      </dxi-item>

                      <dxi-item
                        itemType="group"
                        [colCountByScreen]="{ sm: 1, md: 1 }"
                        [colSpan]="1"
                        cssClass="buttons-group"
                        [verticalAlignment]="true"
                      >
                        <dx-button
                          i18n-text="@@cancel"
                          text="Cancel"
                          stylingMode="contained"
                          class="gt-button gt-btn-left gt-blk-txt add-site-icon"
                          [useSubmitBehavior]="false"
                          (onClick)="onCostEditCanceling($event, cost.data.id)"
                        ></dx-button>

                        <dx-button
                          i18n-text="@@confirmCaps"
                          text="CONFIRM"
                          stylingMode="contained"
                          validationGroup="templateCostConfigForm"
                          [useSubmitBehavior]="true"
                          class="gt-button gt-btn-right gt-blk-txt add-site-icon"
                        ></dx-button>
                      </dxi-item>
                    </dx-form>
                  </dx-validation-group>
                </form>
              </div>
            </dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column dataField="costCategoryName" i18n-caption="@@category" caption="Category"> </dxi-column>

        <dxi-column dataField="isKwpCost" i18n-caption="@@isKwpCost" caption="Cost per size unit"> </dxi-column>

        <dxi-column dataField="attractsUst" i18n-caption="@@attractUst" caption="Attract Ust"> </dxi-column>

        <!-- <dxi-column dataField="isSiteCost" i18n-caption="@@isSiteCost" caption="Site Cost"> </dxi-column> -->

        <dxi-column
          dataField="costNett"
          i18n-caption="@@nettAmount"
          caption="Nett Amount"
          [editorOptions]="{ maxLength: 50, format: nettFormat }"
          [cellTemplate]="cellTemplateFor(cost.data)"
          [format]="nettFormat"
        >
        </dxi-column>

        <dxi-column dataField="milestoneOffsetValue" i18n-caption="@@offset" caption="Offset" format="# weeks">
        </dxi-column>

        <dxi-column
          dataField="milestoneOffsetDirection"
          i18n-caption="@@milestoneOffsetDirection"
          caption="Milestone Offset Direction"
        >
        </dxi-column>

        <dxi-column dataField="costMilestoneName" i18n-caption="@@mMilestone" caption="Milestone"> </dxi-column>

        <dxi-column dataField="notes" i18n-caption="@@notes" caption="Notes"> </dxi-column>

        <dxi-column
          dataField=""
          [visible]="true"
          allowEditing=" false"
          cellTemplate="buttonCellTemplate"
          [width]="'auto'"
          [formItem]="{ visible: false }"
        >
          <div class="cell-with-buttons" *dxTemplate="let item of 'buttonCellTemplate'">
            <div class="cell-button-container">
              <dx-button
                icon="edit"
                class="cell-button edit-button"
                (onClick)="initEditCost($event, cost.data.id, item)"
              >
              </dx-button>
              <dx-button
                icon="clear"
                class="cell-button delete-button"
                (onClick)="initDeleteCost($event, cost.data.id, item)"
              >
              </dx-button>
            </div>
          </div>
        </dxi-column>
      </dx-data-grid>
      <!--                  </div>
                </dxi-item>
            </dx-tab-panel> -->
    </div>
  </dx-data-grid>
</div>

<dx-toast
  [(visible)]="toastVisible"
  i18n-message="@@successfullySaved"
  message="Successfully saved"
  [type]="type"
></dx-toast>

<dx-popup
  [visible]="deleteTemplatePopupVisible"
  (onHiding)="deleteTemplatePopupVisible = false"
  [width]="'auto'"
  [height]="'auto'"
  [title]="confirmDelete"
>
  <span i18n>Are you sure you want to delete this Cost Template?</span>
  <div class="gt-flex-dir-row" style="justify-content: space-between; margin-top: 15px">
    <dx-button
      i18n-text
      [text]="'No'"
      class="gt-button gt-btn-right gt-blk-txt add-site-icon"
      (onClick)="deleteTemplatePopupVisible = false"
    ></dx-button>
    <dx-button
      i18n-text
      [text]="'Yes'"
      class="gt-button gt-btn-right gt-blk-txt add-site-icon"
      (onClick)="deleteCostTemplate()"
    ></dx-button>
  </div>
</dx-popup>

